module.exports = __webpack_public_path__ + "99ea06c679896769d8ee5587da6ff4dd.svg";


//////////////////
// WEBPACK FOOTER
// ./images/social-google.svg
// module id = lQUY
// module chunks = 0